window.Blimp = window.Blimp || {};

class ReportsCollection extends Backbone.Collection {
  get model() {
    return Blimp.Report;
  }

  get url() {
    return '/reports';
  }
}

Blimp.ReportsCollection = ReportsCollection;